











import { Component, Vue } from 'vue-property-decorator';
import Headline from '@/components/about/sections/Headline.vue';
import Story from '@/components/about/sections/Story.vue';
import Team from '@/components/about/sections/Team.vue';
import History from '@/components/about/sections/History.vue';
import Timeline from '@/components/about/sections/Timeline.vue';
import Signup from '@/components/core/Signup.vue';

@Component({
  components: {
    Headline,
    Story,
    Team,
    History,
    Timeline,
    Signup
  }
})
export default class About extends Vue {
}
